import React from "react";
import {
    Box,
    Tooltip,
    Typography,
    IconButton,
    Popover,
    Divider,
} from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import { Link } from "react-router-dom";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import { getQueryParams } from "../../../utils/fns/get-query-params";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

export function PopoverFlashboard({ dataColores }) {
    const [infoTarget, setInfoTarget] = React.useState(null);
    const { t } = useTranslation();

    function onClickInfo(event) {
        setInfoTarget(event.currentTarget);
    }

    function onCloseInfo() {
        setInfoTarget(null);
    }

    return (
        <>
            <Tooltip title="Información">
                <IconButton onClick={onClickInfo} size="small">
                    <HelpIcon style={{ color: "#7786fc" }} />
                </IconButton>
            </Tooltip>
            <Popover
                anchorEl={infoTarget}
                open={Boolean(infoTarget)}
                onClose={onCloseInfo}
                PaperProps={{
                    style: { width: 600, backgroundColor: "rgba(70, 70, 70)" },
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <Box padding={2}>
                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: "flex", alignItems: "right" }}>
                            {t('flashboard-plus.popover.text1')}
                        </div>
                    </Typography>
                    <Typography
                        variant="body1"
                        style={{ color: "white", display: "ruby" }}
                    >
                        {t('flashboard-plus.popover.text2')}{" "}
                        <div
                            style={{
                                width: "13px",
                                height: "13px",
                                borderRadius: "50%",
                                marginRight: "5px",
                                backgroundColor: "#da8e1d",
                            }}
                        ></div>
                        .
                    </Typography>
                    <br />
                    <br />
                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: "flex", alignItems: "right" }}>
                            <strong>
                                {t('flashboard-plus.popover.text3')}
                            </strong>
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: "flex", alignItems: "right" }}>
                            <div
                                style={{
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                    marginRight: "5px",
                                    backgroundColor: "#d42323",
                                }}
                            ></div>
                            <strong>{t('flashboard-plus.popover.text.downtime.title')}:</strong>
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        {t('flashboard-plus.popover.text.downtime.description')}
                    </Typography>

                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: "flex", alignItems: "right" }}>
                            <div
                                style={{
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                    marginRight: "5px",
                                    backgroundColor: "#dacc1d",
                                }}
                            ></div>
                            <strong>{t('flashboard-plus.popover.text.downtime-parcial.title')}:</strong>
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        {t('flashboard-plus.popover.text.downtime-parcial.description')}
                    </Typography>

                    {dataColores.length > 0 && (
                        <Box>
                            <Divider
                                style={{ marginTop: 8, marginBottom: 8 }}
                            />
                            <Typography
                                variant="body1"
                                style={{ color: "white", marginBottom: 5 }}
                            >
                                <strong>{t('flashboard-plus.popover.text.config-limits.title')}</strong>
                            </Typography>
                            <Typography
                                variant="body1"
                                style={{ color: "white", marginBottom: 5 }}
                            >
                                {t('flashboard-plus.popover.text.config-limits.description')}
                                <Link
                                    to={{
                                        pathname: "manageObjectives",
                                        query: { tab: 6 },
                                        search: getQueryParams(),
                                    }}
                                >
                                    <b style={{ color: "white" }}>
                                        &nbsp;{t('flashboard-plus.popover.text.warning.link')}.
                                    </b>
                                </Link>
                            </Typography>
                            <Box
                                display="flex"
                                flexDirection="row"
                                flexWrap="wrap"
                            >
                                {dataColores.map((item, index) => (
                                    <Box key={index} marginRight={2}>
                                        <Typography
                                            variant="body1"
                                            style={{ color: "white" }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "15px",
                                                        height: "15px",
                                                        borderRadius: "50%",
                                                        marginRight: "5px",
                                                        backgroundColor:
                                                            item.color,
                                                    }}
                                                ></div>
                                                <strong>{item.limite} %</strong>
                                            </div>
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                            <Box>
                                <Typography
                                    variant="body1"
                                    style={{ color: "white" }}
                                >
                                    {t('flashboard-plus.popover.text.warning.text1')}{" "}
                                    <CloudOffIcon fontSize="small" />
                                    {t('flashboard-plus.popover.text.warning.text2')}
                                </Typography>
                            </Box>
                            <Divider
                                style={{ marginTop: 8, marginBottom: 8 }}
                            />
                        </Box>
                    )}

                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: "flex", alignItems: "right" }}>
                            <div
                                style={{
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                    marginRight: "5px",
                                    backgroundColor: "#da8e1d",
                                }}
                            ></div>
                            <strong>{t('flashboard-plus.popover.text.warning.title')}:</strong>
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        {t('flashboard-plus.popover.text.warning.description')}
                    </Typography>

                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: "flex", alignItems: "right" }}>
                            <div
                                style={{
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                    marginRight: "5px",
                                    backgroundColor: "#3bb71c",
                                }}
                            ></div>
                            <strong>{t('flashboard-plus.popover.text.uptime.title')}:</strong>
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        {t('flashboard-plus.popover.text.uptime.description')}
                    </Typography>
                    <br />
                    <Typography
                        variant="body1"
                        style={{ color: "white", display: "ruby" }}
                    >
                        {t('flashboard-plus.popover.text4')}
                    </Typography>
                </Box>
            </Popover>
        </>
    );
}
